const normalizeValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return value ? 1 : 0;

  const dateValue = Date.parse(value);
  if (!Number.isNaN(dateValue) && String(value).includes("-")) {
    return dateValue;
  }

  return String(value).toLowerCase();
};

const getNestedValue = (row, path) =>
  String(path || "")
    .split(".")
    .reduce((value, key) => value?.[key], row);

export const getSortOrder = (sortName, sortDirection) =>
  sortName && sortDirection
    ? { name: sortName, direction: sortDirection }
    : undefined;

export const sortTableData = (data, sortName, sortDirection, accessors = {}) => {
  if (!sortName || !sortDirection || !Array.isArray(data)) return data;

  const getValue =
    accessors[sortName] || ((row) => getNestedValue(row, sortName));
  const directionMultiplier = sortDirection === "desc" ? -1 : 1;

  return [...data].sort((firstRow, secondRow) => {
    const firstValue = normalizeValue(getValue(firstRow));
    const secondValue = normalizeValue(getValue(secondRow));

    if (firstValue < secondValue) return -1 * directionMultiplier;
    if (firstValue > secondValue) return 1 * directionMultiplier;
    return 0;
  });
};
